import { ReactElement } from 'react';
import { JobSettingsFormContainer } from '../../../../modules/jobs/containers/details/JobSettingsForm.container';

export const TrainingDetailsSettingsView = (): ReactElement => <JobSettingsFormContainer />;
